import { ShieldCheck } from "lucide-react";
import { Link } from "react-router-dom";

export const Footer = () => {
  return (
    <footer className="border-t border-[#1E293B] bg-[#0F172A]/40">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-10 flex flex-col sm:flex-row items-center justify-between gap-6">
        <div className="flex items-center gap-2.5">
          <ShieldCheck className="w-5 h-5 text-[#D4AF37]" />
          <span className="font-head font-black tracking-[0.18em] text-[#F8FAFC] text-sm">
            BODYGUARD<span className="text-[#D4AF37]"> EXP</span>
          </span>
        </div>
        <p className="font-body text-xs text-[#94A3B8] text-center">
          Oakland HQ · Now serving the SF Bay Area & Sacramento
        </p>
        <div className="flex items-center gap-6 font-body text-xs text-[#94A3B8]">
          <a href="#" className="hover:text-[#D4AF37] transition-colors">Terms</a>
          <a href="#" className="hover:text-[#D4AF37] transition-colors">Privacy</a>
          <Link to="/admin" data-testid="footer-admin-link" className="hover:text-[#D4AF37] transition-colors">Admin</Link>
        </div>
      </div>
    </footer>
  );
};
